export const EXTERNAL_LINKS = {
  BLOG: 'https://treuhand-suche.ch/blog/',
  BLOG_FORM: 'https://treuhand-suche.ch/blog/form/',
  BLOG_FAQ: 'https://treuhand-suche.ch/blog/faq/',
  FORUM: 'https://treuhand-suche.ch/forum/',
  FACEBOOK: 'https://www.facebook.com/Treuhand-suchech-2059437657690758/',
  LINKED_IN: 'https://www.linkedin.com/company/19082161/admin/?welcome=true'
};
